module.exports = __webpack_public_path__ + "img/CB7146_551D0F_7C270D_E5AB9C-256px.428d41ea.png";